module.exports = __webpack_public_path__ + "img/icon-011.0eb18b40.png";